'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createRoot } from 'react-dom/client';
import { Small } from 'foundations-components/transitional/components/Small';
import { List } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.removeAllConnectionsPrompt';
class DisconnectInboxesPrompt extends Component {
  render() {
    const {
      onConfirm,
      onReject,
      emailAddress,
      usersEmails
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      use: "danger",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onReject
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.heading`,
            options: {
              emailAddress
            }
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.otherAccountsPreface`
          })
        }), /*#__PURE__*/_jsx(List, {
          styled: true,
          wrapChildren: true,
          children: usersEmails.map(email => /*#__PURE__*/_jsx("span", {
            children: email
          }, email))
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.howToConnect`,
            options: {
              emailAddress
            }
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "danger",
          onClick: onConfirm,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.disconnectUsersButton`
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          onClick: onReject,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.cancelButton`
          })
        }), /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.disconnectionNotice`
          })
        })]
      })]
    });
  }
}
DisconnectInboxesPrompt.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  emailAddress: PropTypes.string.isRequired,
  usersEmails: PropTypes.arrayOf(PropTypes.string).isRequired
};
function RemoveAllConnectionsPrompt(props) {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);
    const cleanup = () => {
      root.unmount();
      document.body.removeChild(container);
    };
    const handleConfirm = () => {
      cleanup();
      resolve();
    };
    const handleReject = error => {
      cleanup();
      reject(error);
    };
    root.render( /*#__PURE__*/_jsx(ThemeProvider, {
      children: /*#__PURE__*/_jsx(DisconnectInboxesPrompt, Object.assign({}, props, {
        onConfirm: handleConfirm,
        onReject: handleReject
      }))
    }));
  });
}
export default RemoveAllConnectionsPrompt;